import { render, staticRenderFns } from "./SendIcon.vue?vue&type=template&id=0dd514b6&scoped=true"
var script = {}
import style0 from "./SendIcon.vue?vue&type=style&index=0&id=0dd514b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd514b6",
  null
  
)

export default component.exports